import React, {  useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import Box from '@mui/material/Box';  
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import PropTypes from 'prop-types'; 
import TableSortingArticlesButtonArticle from "pages/settings/articlesButtonSettings/SortingTablesArticlesButtonArticles"

const initialFiltersArticles= {
  "idFrom":"",
  "idTo":"",
  "codeFrom":"",
  "codeTo":"",
  "nameesFrom":"",
  "nameesTo":"",
  "nameenFrom":"",
  "nameenTo":""
};
 
const initialStateArticles = [{
  "article_id": "",
  "article_code":"",
  "article_namees": "",
  "article_nameen": ""
  
}];
        

const ArticlesButtonSearchArticles = ({ showModalSearchArticles, setShowModalSearchArticles,setForm}) => {
  const {t,i18n} = useTranslation(['listDataGeneralSettings']);
  const token = useSelector((state) => state.loginUser.token);  
  const LIMITPAGESIZE = useSelector((state) => state.loginUser.defaultticketsformat.limitpagesizetickes);
  const [dataArticle, setDataArticle] = useState(initialStateArticles);
  const [isLoadingErrorArticle, setIsLoadingErrorArticle] = useState(false);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [inputTextArticle, setInputTextArticle] = useState("");
  const [applyFiltersArticle, setApplyFiltersArticle]= useState(initialFiltersArticles);
  const [filtersArticle, setFiltersArticle]= useState(initialFiltersArticles);
  const [openEditFilterArticle,setOpenEditFilterArticle]= useState(false);
  const [errorsFiltersArticle, setErrorsFiltersArticle] = useState({});
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegArticle,setNumTotRegArticle]= useState(0);
  const [activeOffsetArticle, setActiveOffsetArticle]= useState(false);
  const [currencyOffsetArticle, setCurrencyOffsetArticle] = useState(0);
  const [rangeOffsetArticle, setRangeOffsetArticle] = useState([{}]); 
  const dispatch = useDispatch(); 
   
  const handleCloseDataEditArticle = () => {
    setDataArticle(initialStateArticles);
    setIsLoadingErrorArticle(false);
    dispatch(setLoading(false));
    setInputTextArticle("");
    setApplyFiltersArticle(initialFiltersArticles);
    setFiltersArticle(initialFiltersArticles);
    setOpenEditFilterArticle(false);
    setErrorsFiltersArticle({});
    setNumTotRegFilter(0);
    setNumTotRegArticle(0);
    setActiveOffsetArticle(false);
    setCurrencyOffsetArticle(0);
    setRangeOffsetArticle([{}]); 
    setShowModalSearchArticles(false)
	};

  const toggleDrawerSearchFormArticle  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditArticle();
    }
  };

  let inputHandlerArticle = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextArticle(lowerCase);
  };

  const openEditFiltersArticle = () => {
    setFiltersArticle(applyFiltersArticle);
    setOpenEditFilterArticle(!openEditFilterArticle);
  };

  const toggleDrawerFilterEditArticle = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditArticle();
    }
  };

  const handleCancelFiltersArticle = () => {
    setErrorsFiltersArticle({});
    setFiltersArticle(initialFiltersArticles);
    setOpenEditFilterArticle(!openEditFilterArticle);
  };

  const handleChangeFilterEditArticle = (e) => {
    const { name, value } = e.target;
    setFiltersArticle(filtersArticle => ({
      ...filtersArticle,
      [name]: value
    }));
  };

  const handleBlurFilterEditArticle = (e) => {
    setErrorsFiltersArticle(validateFormFilterArticle());
    handleChangeFilterEditArticle(e);
  };
 
  const handleSubmitFilterEditArticle = () => {
    setErrorsFiltersArticle(validateFormFilterArticle());
    if (Object.keys(errorsFiltersArticle).length === 0) {
      setApplyFiltersArticle(filtersArticle);
      setFiltersArticle(initialFiltersArticles);
      setErrorsFiltersArticle({});
      setOpenEditFilterArticle(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  const handleDeleteFiltersArticle = () => {
    setErrorsFiltersArticle({});
    setFiltersArticle(initialFiltersArticles);
    setApplyFiltersArticle(initialFiltersArticles);
    setOpenEditFilterArticle(!openEditFilterArticle);
  };

  const validateFormFilterArticle = () => {
    let errorsFiltersArticle = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filtersArticle.idFrom!=="" & !regexNumber.test(filtersArticle.idFrom)) {
      errorsFiltersArticle.idFrom = 'Text_TextNoNumber';
    }
    if (filtersArticle.idTo!=="" & !regexNumber.test(filtersArticle.idTo)) {
      errorsFiltersArticle.idTo = 'Text_TextNoNumber';
    }
    if (filtersArticle.idFrom!=="" & !errorsFiltersArticle.idFrom!==undefined){
      if (filtersArticle.idTo!=="" & !errorsFiltersArticle.idTo!==undefined){
        if (parseInt(filtersArticle.idTo)<parseInt(filtersArticle.idFrom)){
          errorsFiltersArticle.idTo = 'Text_TextGreater_Id';
        }
      }
    }
    if (regexInvalidCharacters.test(filtersArticle.nameesFrom)) {
      errorsFiltersArticle.nameesFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.nameesTo)) {
      errorsFiltersArticle.nameesTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.nameenFrom)) {
      errorsFiltersArticle.nameenFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.nameenTo)) {
      errorsFiltersArticle.nameenTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.codeFrom)) {
      errorsFiltersArticle.codeFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.codeTo)) {
      errorsFiltersArticle.codeTo = 'Text_TextNoValid';
    } 
    if (filtersArticle.nameesTo!=="" & filtersArticle.nameesTo<filtersArticle.nameesFrom){
      errorsFiltersArticle.nameesTo = 'Text_TextGreater_Namees';
    }
    if (filtersArticle.nameenTo!=="" & filtersArticle.nameenTo<filtersArticle.nameenFrom){
      errorsFiltersArticle.nameenTo = 'Text_TextGreater_Nameen';
    }
    if (filtersArticle.codeTo!=="" & filtersArticle.codeTo<filtersArticle.codeFrom){
      errorsFiltersArticle.codeTo = 'Text_TextGreater_Article';
    }
    return errorsFiltersArticle;
  }  

  const filtereddataArticle = dataArticle.filter((el) => {
    if (inputTextArticle === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.article_id || '') +
        String(el.article_namees || '') +
        String(el.article_nameen || '') + 
        String(el.article_code || '');
      let result = dataTranslate.toLowerCase().includes(inputTextArticle.toLowerCase());
      return result;
    }
  })

  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegArticle = async () => {
      try { 
        const getData = await helpHttp().get(ENDPOINT, `articlesbutton/getinformationtablearticle`, token);
        if (getData.err) {
          setDataArticle(initialStateArticles);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegArticle(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = await helpHttp().post(ENDPOINT, `articlesbutton/getcountfilterarticle`, token, applyFiltersArticle);
        if (getData.err || getData.message === "Load failed") {
          setDataArticle(initialStateArticles);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    const fetchdataArticle = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get3(ENDPOINT,`articlesbutton/getarticles`,token,currencyOffsetArticle,LIMITPAGESIZE,applyFiltersArticle);
        if (getData.err || getData.message === "Load failed") {
          setDataArticle(initialStateArticles);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataArticle(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    
    if (showModalSearchArticles){
      fetchnumTotRegArticle();
      fetchnumTotRegFilter();
      fetchdataArticle();
    }
    return () => { isMounted = false };
  }, [t,i18n,token,dispatch,LIMITPAGESIZE,applyFiltersArticle,currencyOffsetArticle,showModalSearchArticles]);

  return(
    <>
      {showModalSearchArticles && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchFormArticle(false)}
            onOpen={toggleDrawerSearchFormArticle(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'1300px', width: '1100px'}}>
                <br/>
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                   {isLoadingErrorArticle?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_Article_Table')}
                  </h1>
                 <div>
                    <button type="button" className="formdi-pending-btn formdi-pending-btn--primary" onClick={handleCloseDataEditArticle}>{t('Button_Back')}</button><> </>
                  </div> 
                </div>  
                <br/>
                <div className="formdi-pending-search">
                 <TextField
                    id="outlined-basic"
                    variant="outlined"
                    value={inputTextArticle}
                    inputProps={{ style: {fontSize: '18px'} }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
                    placeholder={t('Text_Article_Search')} 
                    onChange={inputHandlerArticle}
                    fullWidth
                    label={t('Text_Article_Search')}>
                  </TextField>
                </div>
                <br/>
                <div id="myNewDIV" className="formdi-pending-filters">
                  <h1 className="formdi-pending-filter-title">{t('Text_Filter')}</h1> 
                    <div className="formdi-pending-filters-row">
                      <button type="button" className={`formdi-pending-chip ${applyFiltersArticle.idFrom !== "" || applyFiltersArticle.idTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersArticle} >
                        <span className={`formdi-pending-dot ${ applyFiltersArticle.idFrom !== "" || applyFiltersArticle.idTo !== ""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_Code")}
                      </button>
                      <button type="button" className={`formdi-pending-chip ${applyFiltersArticle.codeFrom !== "" || applyFiltersArticle.codeTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersArticle} >
                        <span className={`formdi-pending-dot ${ applyFiltersArticle.codeFrom !== "" || applyFiltersArticle.codeTo !== ""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_ArticlesButton_article_code")}
                      </button>
                      <button type="button" className={`formdi-pending-chip ${applyFiltersArticle.nameesFrom!=="" || applyFiltersArticle.nameesTo!=="" || applyFiltersArticle.nameenFrom!=="" || applyFiltersArticle.nameenTo!==""? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersArticle} >
                        <span className={`formdi-pending-dot ${applyFiltersArticle.nameesFrom!=="" || applyFiltersArticle.nameesTo!=="" || applyFiltersArticle.nameenFrom!=="" || applyFiltersArticle.nameenTo!==""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_Name")}
                      </button>
                      
                  </div>
                </div> 
                <br/>
                {!isLoadingData?
                  <>
                    <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content">
                        <TableSortingArticlesButtonArticle
                          dataArticle={filtereddataArticle}
                          numTotRegFilter={ numTotRegFilter}
                          titleTable={t('Text_Article_Table')}
                          numTotRegArticle={numTotRegArticle}
                          activeOffsetArticle={activeOffsetArticle}
                          rangeOffsetArticle={rangeOffsetArticle}
                          currencyOffsetArticle={currencyOffsetArticle}
                          setCurrencyOffsetArticle={setCurrencyOffsetArticle}
                          setForm={setForm}
                          handleCloseDataEditArticle={handleCloseDataEditArticle}
                        >
                        </TableSortingArticlesButtonArticle>
                      </div>             
                    </div>
                    {openEditFilterArticle &&
                      <div>
                      <SwipeableDrawer
                        anchor='right'
                        open={true}
                        onClose={toggleDrawerFilterEditArticle(false)}
                        onOpen={toggleDrawerFilterEditArticle(true)}>
                        <Container >
                          <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                            <br/>
                              <div id="myDIV">
                                <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                              </div>
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <form className="newfilterformstore" onSubmit={handleCancelFiltersArticle}>  
                                <div className="form-floating mb-3 px-4 primary">
                                  <div className="form-group">
                                    <TextField
                                      id="idFrom" 
                                      name="idFrom"
                                      value={filtersArticle.idFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsFiltersArticle.idFrom!=null?t(errorsFiltersArticle.idFrom):t('Text_Filter_Code_From')}
                                      placeholder={t('PlaceHolder_Filter_Code_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id="idTo" 
                                      name="idTo"
                                      value={filtersArticle.idTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsFiltersArticle.idTo!=null?t(errorsFiltersArticle.idTo):t('Text_Filter_Code_To')}
                                      placeholder={t('PlaceHolder_Filter_Code_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField
                                      id="codeFrom" 
                                      name="codeFrom"
                                      value={filtersArticle.codeFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 10 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsFiltersArticle.codeFrom!=null?t(errorsFiltersArticle.codeFrom):t('Text_Filter_Article_From')}
                                      placeholder={t('PlaceHolder_Filter_Article_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <TextField
                                      id="codeTo" 
                                      name="codeTo"
                                      value={filtersArticle.codeTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 10 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsFiltersArticle.codeTo!=null?t(errorsFiltersArticle.codeTo):t('Text_Filter_Article_To')}
                                      placeholder={t('PlaceHolder_Filter_Article_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField
                                      id="nameesFrom" 
                                      name="nameesFrom"
                                      value={filtersArticle.nameesFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.nameesFrom!=null?t(errorsFiltersArticle.nameesFrom):t('Text_Filter_NameEs_From')}
                                      placeholder={t('PlaceHolder_Filter_NameEs_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id="nameesTo" 
                                      name="nameesTo"
                                      value={filtersArticle.nameesTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.nameesTo!=null?t(errorsFiltersArticle.nameesTo):t('Text_Filter_NameEs_To')}
                                      placeholder={t('PlaceHolder_Filter_NameEs_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField
                                      id="nameenFrom" 
                                      name="nameenFrom"
                                      value={filtersArticle.nameenFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.nameenFrom!=null?t(errorsFiltersArticle.nameenFrom):t('Text_Filter_NameEn_From')}
                                      placeholder={t('PlaceHolder_Filter_NameEn_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id="nameenTo" 
                                      name="nameenTo"
                                      value={filtersArticle.nameenTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.nameenTo!=null?t(errorsFiltersArticle.nameenTo):t('Text_Filter_NameEn_To')}
                                      placeholder={t('PlaceHolder_Filter_NameEn_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>  
                                </div>
                                <hr className="sidebar-divider d-none d-md-block"/>
                                <div className="formdi-pending-action-group">
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditArticle}>
                                    {t('Button_Apply')}
                                  </button> 
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersArticle}>
                                    {t('Button_Cancel_Filters')}
                                  </button>
                                </div>  
                            </form>
                          </Box>
                        </Container>
                      </SwipeableDrawer>
                    </div>
                  }   
                  {/* End Content Row */}
                  </>:
                    <LoadingNews/>
                } 
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

ArticlesButtonSearchArticles.propTypes = {
  showModalSearchArticles: PropTypes.bool.isRequired,
  setShowModalSearchArticles: PropTypes.func.isRequired,
  setForm: PropTypes.func.isRequired
};

export default ArticlesButtonSearchArticles;

